import { NgFor } from "@angular/common";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Input, OnInit, ViewChild, ViewEncapsulation } from "@angular/core";
import { firstValueFrom, Observable } from "rxjs";
import { NoticiasService } from "../../../servicios/noticias/noticias.service";
import { NoticiaComponent } from "../noticia/noticia.component";

@Component({
  selector: "app-bloque-patrocinados",
  templateUrl: "./bloque-patrocinados.component.html",
  styleUrls: ["./bloque-patrocinados.component.scss"],
  encapsulation: ViewEncapsulation.None,
  imports: [NoticiaComponent, NgFor],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BloquePatrocinadosComponent implements OnInit {
  noticias: Observable<any[]>[] = [];
  @Input() idSeccion;
  @Input() idStart: number;

  @ViewChild("publiBloquePatrocinados", { static: false }) publiBloquePatrocinados: ElementRef<HTMLDivElement>;

  constructor(
    private readonly noticiasService: NoticiasService,
    private readonly cd: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    const sectionNews = this.noticiasService.getNoticiasSeccion(this.idSeccion, 8, "subcanal", null);
    if (sectionNews) {
      firstValueFrom(sectionNews).then((noticias) => {
        this.noticias = noticias;
        this.cd.detectChanges();
      });
    }
  }
}
